import * as React from 'react';
import { Typography, Grid } from '@mui/material';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles'



export default function ProgressBar(props) {
  const { value, name, guess, maxWidth, tooltipText } = props;
  const { AnswerCategory, QuestionMarkers, GridHeight, SliderPercentage, GridMargin } = styles;

  return (
    <GridMargin container xs={12} justifyContent={"space-evenly"} alignItems={"center"}>
      {/* <Grid xs={1} textAlign={"center"}></Grid> */}
      <Grid xs={3} textAlign={"center"}>
        <AnswerCategory>
          {name}
          <Tooltip title={tooltipText}>
            <IconButton>
              <QuestionMarkers />
            </IconButton>
          </Tooltip>
        </AnswerCategory>
      </Grid>
      <Grid xs={9}>
        <Grid container alignItems={'center'}>
          <GridHeight style={{ background: "#003e4c", borderRadius: 2, width: `${value*maxWidth}%` }}></GridHeight>
          <SliderPercentage lineHeight={0.5} >{value}%</SliderPercentage>
        </Grid>
        <Grid container alignItems={'center'}>
          <GridHeight style={{ marginTop: 1,  background: "#00b1d9", borderRadius: 2, width: `${guess*maxWidth}%`, maxWidth: "80%"}}></GridHeight>
          <SliderPercentage lineHeight={0.5}>{guess}%</SliderPercentage>
        </Grid>
      </Grid>
      {/* <Grid xs={1} textAlign={"center"}></Grid> */}
    </GridMargin>
  );
}
